export default class AssistApi {
  constructor(
    private readonly domain: string,
    private readonly organisationId?: string,
    private readonly tenantId?: string,
  ) {
    if (!domain.startsWith('https://') && !domain.startsWith('http://')) {
      this.domain = `https://${this.domain}`
    }

    if (this.domain.endsWith('/')) {
      this.domain = this.domain.slice(0, -1)
    }
  }

  addScriptTag() {
    const script = document.createElement('script')
    script.src = `${this.domain}/Scripts/GetScripts/eco-suite-navbar/${this.organisationId ?? this.tenantId}`
    script.async = true
    document.head.appendChild(script)
  }
}
